var render = function render(){var _vm=this,_c=_vm._self._c;return _c('zg-module',_vm._b({},'zg-module',_vm.moduleProps,false),[_c('zg-quoted-by',_vm._b({},'zg-quoted-by',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }